// Colunas do grid.
export const Columns = [
	{
		headerName: 'name',
		field: 'name',
		filter: true
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans'
	}
]